module.exports = __webpack_public_path__ + "img/levelup-top-shape.71b21ebf.svg";